<template>
  <div class="container bg-gray-100 p-5 mb-5 md:pl-20 md:pr-20">
    <div
      class="container pt-10 md:pl-48 md:pr-48 lg:pl-40 xl:pl-40 bg-white rounded-lg p-5 box-shadow text-lightBlack"
    >
      <div class="flex justify-center">
        <p class="text-center text-2xl lg:text-3xl mb-5">Firma Digital</p>
        <p v-show="!showSummary" v-on:click="toggleShowSummary">
          <mdicon name="chevron-right" />
        </p>
        <p v-show="showSummary" v-on:click="toggleShowSummary">
          <mdicon name="chevron-down" />
        </p>
      </div>
      <!--Summary-->
      <div v-if="!showSummary">
        <div class="flex sm:text-lg text-lightBlack font-semibold md:mb-2">
          <div class="w-full">
            <p>Plan</p>
          </div>
          <div class="w-full text-right font-bold">
            <p>Suma Asegurada</p>
          </div>
        </div>

        <div
          class="flex items-center md:text-base text-lightBlack"
          v-for="products in selected_products"
          :key="products.product_id"
        >
          <div class="w-full md:mb-2">
            <p>{{ products.product_name }}</p>
          </div>
          <div class="w-full text-right">
            <p>{{ $filters.toCurrency(products.sum_assured)}}</p>
          </div>
        </div>
        <div
          class="mt-4 md:text-base text-lightBlack md:mb-5"
          v-if="personalData != null"
        >
          <div class="w-full sm:text-lg font-semibold md:mb-2">
            <p>Información Personal</p>
          </div>
          <div class="w-full">
            <label class="mt-5 mb-2">
              {{ name }}
            </label>
          </div>
          <p>{{ personalData.date_birth }}</p>
          <p>{{ personalData.gender == "H" ? "Hombre" : "Mujer" }}</p>
          <p>{{ personalData.marital_status }}</p>
          <p>Colonia: {{ personalData.neighborhood }}</p>
          <p>Calle: {{ personalData.street }}</p>
          <p>No. {{ personalData.exterior_number }}</p>
          <p>Email: {{ personalData.emails }}</p>
          <p>
            Celular: ({{ personalData.lada_cellphone }})
            {{ personalData.cellphone_number }}
          </p>
        </div>
        <div class="mt-4" v-if="workplace">
          <div class="w-full sm:text-lg text-lightBlack font-semibold md:mb-2">
            <p>Información Laboral</p>
          </div>
          <div class="w-full md:text-base">
            <p>Estatus: {{ workplace.status }}</p>
            <p>Base: {{ workplace.base }}</p>
            <p v-if="workplace.delegation">
              Delegación: {{ workplace.delegation }}
            </p>
          </div>
        </div>
        <div class="mt-2 text-gray-500" v-if="beneficiaryArray.length > 0">
          <div class="inline-block cursor-pointer" v-if="!showBeneficiary" v-on:click="toggleShowBeneficiary">
            Ver Beneficiarios <mdicon name="chevron-right" />
          </div>
          <div class="inline-block cursor-pointer" v-if="showBeneficiary" v-on:click="toggleShowBeneficiary">
            Ocultar Beneficiarios <mdicon name="chevron-down" />
          </div>
        </div>

        <div class="md:inline-flex lg:inline-flex xl:inline-flex w-full">
          <!-- Beneficiaries-->
          <div
            v-if="showBeneficiary && beneficiaryArray.length > 0"
            class="w-full md:w-2/3 lg:w-2/3 xl:w-2/3"
          >
            <div
              class="flex justify-center"
              v-for="(beneficiary, index) in beneficiaryArray"
              :key="index"
            >
              <div class="w-2/3 lg:w-1/2 md:w-1/2 xl:w-1/2 items-center mt-2">
                <div class="">
                  <label class="mt-2 mb-2">
                    {{
                      beneficiary.first_name +
                      " " +
                      (beneficiary.second_name ? beneficiary.second_name : "") +
                      " " +
                      beneficiary.paternal_lastname +
                      " " +
                      (beneficiary.maternal_lastname
                        ? beneficiary.maternal_lastname
                        : "")
                    }}
                  </label>
                </div>
                <div class="">
                  <p class="text-xs text-gray-600">
                    {{ beneficiary.date_birth }}
                  </p>
                  <p class="text-xs text-gray-600">
                    {{ beneficiary.kinship }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <!-- Economic Dependents -->
          <div class="mt-2 text-gray-500" v-if="economicDependents.length > 0">
            <p
              v-show="!showEconomicDependent"
              v-on:click="toggleShowEconomicDependent"
            >
              Ver Dependiente Económico <mdicon name="chevron-down" />
            </p>
            <p
              v-show="showEconomicDependent"
              v-on:click="toggleShowEconomicDependent"
            >
              Ocultar Dependiente Económico <mdicon name="chevron-right" />
            </p>
          </div>
          <div
            v-if="showEconomicDependent && economicDependents.length > 0"
            class="w-full md:w-2/3 lg:w-2/3 xl:w-2/3"
          >
            <div class="flex">
              <div class="w-2/3 lg:w-1/2 md:w-1/2 xl:w-1/2 items-center mt-5">
                <div class="">
                  <label class="mt-5 mb-2">
                    {{
                      economicDependents[0].first_name +
                      " " +
                      (economicDependents[0].second_name
                        ? economicDependents[0].second_name
                        : "") +
                      " " +
                      economicDependents[0].paternal_lastname +
                      " " +
                      (economicDependents[0].maternal_lastname
                        ? economicDependents[0].maternal_lastname
                        : "")
                    }}
                  </label>
                </div>
                <div class="">
                  <label class="mt-5 mb-2 text-xs text-gray-600">
                    {{ economicDependents[0].kinship }}
                  </label>
                </div>
                <div class="">
                  <label class="mt-5 mb-2 text-xs text-gray-600">
                    {{ economicDependents[0].date_birth }}
                  </label>
                </div>
                <div class="">
                  <label class="mt-5 mb-2 text-xs text-gray-600">
                    {{
                      economicDependents[0].gender == "H" ? "Hombre" : "Mujer"
                    }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-col md:w-3/3 text-right">
        <div class="mb-2">
          <p>__________________</p>
        </div>
        <div class="inline-flex items-center text-right">
          <div class="w-full">
            <p>Total Quincenal:</p>
          </div>
          <div class="ml-2 text-3xl">
            <p>{{ $filters.toCurrency(totalSumQnal) }}</p>
          </div>
        </div>
      </div>
      <!--Sing-->
      <div>
        <div class="flex justify-center mt-10">
          <p class="text-center text-xl lg:text-2xl">Autorizo de descuento</p>
          <p v-show="!showAuthorize" v-on:click="toggleShowAuthorize">
            <mdicon name="chevron-right" />
          </p>
          <p v-show="showAuthorize" v-on:click="toggleShowAuthorize">
            <mdicon name="chevron-down" />
          </p>
        </div>
        <div class="w-full mt-5">
          <div v-if="showAuthorize">
            <p class="text-sm md:text-xl text-justify md:leading-relaxed">
              Por este conducto autorizo que la cantidad
              {{$filters.toCurrency(totalSumQnal) }} sea descontada de mis sueldo
              durante XX pagos o hasta cubrir la totalidad de mis seguros. Para
              cualquier aclaración o reclamo se utilizarán los comprobantes de
              sueldo (talón de cheque) los cuales presentaré en el momento
              requerido. Así mismo estoy de acuerdo en que sí por cualquier
              circunstancia no se me descuenta la cantidad pactada, ésta sea
              aplicada en las quincenas subsecuentes. Acepto que se proceda a la
              cancelación de los beneficios adquiridos si, por cualquier motivo,
              no se me puede aplicar descuento o no realizo los pagos
              correspondientes por 3 quincenas consecutivas o bien si por
              descuentos incompletos acumulo un adeudo por un momento
              equivalente a 3 quincenas de aportación, y no regularizo esta
              situación en las oficinas de Línea Magisterial. Hago constar que
              estoy enterado(a) y de acuerdo con cada uno de los puntos
              anteriores por lo que firmo de conformidad en uso de los
              facultades mentales. <br />
              Los valores autorizados en este documento son fijos por el periodo
              de un año a partir de la fecha de contratación de los seguros y
              autorizo las variaciones a la alza o a la baja para las
              correspondientes renovaciones automáticas , que podrán ser con la
              compañía de seguros autorizada o con otra compañía de seguros que
              no afecte las coberturas contratadas, Autorizo se verifique la
              liquidez a través del talón de cheque o de medios electrónicos. Si
              el asegurado desea no continuar con la protección debe acudir a
              las oficinas de Línea Magisterial para trámite de cancelación o
              solicitarlo a través de nuestros promotores. Las aportaciones para
              maestros con licencia se harán directamente en las oficinas de
              Línea Magisterial.
            </p>
          </div>
          <div class="text-center mt-5 mb-5 px-10 items-center">
            <span>He leído y acepto las condiciones del </span
            ><a
              class="text-goodGreen"
              href=""
              v-on:click.prevent="getPrivacynotice()"
              >Aviso de Privacidad</a
            >
          </div>
          <div class="text-center mb-5">
            <button
              v-bind:class="[
                'hover:bg-darkGray text-xl py-1 px-10 m-2 rounded-full',
                acceptConditions ? 'activeClass' : 'bg-lightGray',
              ]"
              v-on:click="
                (notice_of_privacy_type =
                  'plan_costos_v200501_recibi_reglamento_si'),
                  (acceptConditions = true)
              "
            >
              Sí
            </button>
            <button
              v-bind:class="[
                'hover:bg-darkGray text-xl py-1 px-10 m-2 rounded-full',
                acceptConditions === false ? 'activeClass' : 'bg-lightGray',
              ]"
              v-on:click="
                (notice_of_privacy_type =
                  'plan_costos_v200501_recibi_reglamento_no'),
                  (acceptConditions = false)
              "
            >
              No
            </button>
          </div>
          <!--Validated Mati -->
          <div v-if="reference === null">
          <div
            v-show="
              !user_is_validated && !documents_send_cincel && acceptConditions
            "
          >
            <div class="mt-10 mb-10 text-center">
              <!-- <p class="text-base md:text-xl font-semibold">
                Verificación de identidad
              </p> -->
              <br />
              <div class="flex-1 bg-gray-0 px-0 py-0 m-0">
                <div class="row">
                  <center>
                    <!--
                    <script
                      src="https://web-button.mati.io/button.js"
                      type="application/javascript"
                    ></script>
                    -->

                   
                    <!-- <div  v-html="matiButtonLink()"></div>
                    <div v-html="matiButton()"></div> -->
                  </center>
                </div>
              </div>
            </div>
          </div>
          </div>
          <!--Digital signature -->
          <div v-if="reference === null">
            <div
              v-show="
                user_is_validated &&
                !documents_is_sended &&
                !documents_send_cincel
              "
            >
              <div class="text-center">
                <p
                  class="text-orangePrimary text-base md:text-xl font-semibold"
                ></p>
                <button
                  class="bg-normalYellow hover:bg-hoverYellow text-white text-xl py-2 px-20 rounded-full"
                  v-on:click="sendDocumentCincel()"
                >
                  Firmar
                </button>
              </div>
            </div>
          </div>
          <div v-show="isLoading" class="m-5 flex justify-center">
            <loading
                 :style="{ height: '15px'  }"
                 color="#fff"
                 class="static"
                 :active="isLoading"
                 loader="dots"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="false"
                />
          </div>
          <!--Messages-->
          <div class="text-center px-5" v-if="acceptConditions == false">
            <span class="text-red-600 text-xl font-semibold"
              >Debes aceptar las condiciones del Aviso de Privacidad para
              continuar</span
            >
          </div>

          <div
            class="text-center px-5 mt-5"
            v-if="documents_is_sended || documents_send_cincel"
          >
            <span class="text-red-600 text-xl font-semibold">{{
              massage
            }}</span>
          </div>

          <div
            class="text-center px-5 mt-5"
            v-if="!documents_is_sended && !documents_send_cincel"
          >
            <span class="text-red-600 text-xl font-semibold">{{ errors }}</span>
          </div>

          <div class="text-center mt-10 mb-5">
            <button
              v-if="acceptConditions"
              @click="finish"
              class="bg-lightGray hover:bg-darkGray text-xl py-1 px-10 m-2 rounded-full"
            >
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
                    
import axios from "axios";

//import Loading from "@/components/Loading/VueLoading.vue";

export default {
  name: "DigitalSignature",
  data() {
    return {
      reference: null,
      apiCabsaCore: process.env.VUE_APP_APICABSACORE,
      api_lineamagisterialproducts:
        process.env.VUE_APP_APILINEAMAGISTERIALPRODUCTS,
      personalData: null,
      beneficiaryArray: [],
      economicDependents: [],
      workplace: [],
      showSummary: false,
      showAuthorize: false,
      showBeneficiary: false,
      showEconomicDependent: false,
      isLoading: false,
      selected_products: [],
      cellphone_number: null,
      totalSumQnal: 0,
      token_auth_valid: "",
      is_url_expiration: false,
      url_is_expiration: false,
      errors: null,
      url_response_json: null,
      notice_of_privacy_type: "",
      urlParams: null,
      json_file: null,
      data: null,
      acceptConditions: null,
      section: null,
      policy: "",
      plan_a_policy_request_id: "",
      plan_b_policy_request_id: "",
      user_is_validated: null,
      documents_is_sended: null,
      documents_send_cincel: null,
      name: null,
      massage:
        "Se envió correo para la firma de la solicitud y autorizo de descuento , tiene una validez de 24 horas, la compra va a finalizar hasta que se realice la firma, de lo contrario se cancelará.",

      matiClientId: "5f495673aec413001bb291af",
      business: "3",
      matiFlowid: "6005a7ead4414a001b8ebbae",
      matiStatusVerification: "",
      mati_identity_id: null,
    };
  },
  async mounted() {
    document
      .getElementById("btnMati")
      .addEventListener("mati:loaded", ({ detail }) => {
        localStorage.removeItem("mati_identity_id");
        this.mati_identity_id = localStorage.mati_identity_id;
        console.log("finishedloaded ", detail);
      });
    document
      .getElementById("btnMati")
      .addEventListener("mati:userFinishedSdk", ({ detail }) => {
        console.log("userFinishedSdk ", detail);
        localStorage.setItem("mati_identity_id", detail.identityId);
        this.mati_identity_id = localStorage.mati_identity_id;
        this.getStatusVerification();
        console.log("finisheduserFinishedSdk ", detail);
      });
    document
      .getElementById("btnMati")
      .addEventListener("mati:exitedSdk", ({ detail }) => {
        console.log("finishedexitedSdk ", detail);
      });
  },
  async beforeMount() {
    this.reference = sessionStorage.getItem('reference');
    this.urlParams = new URLSearchParams(window.location.search);
    this.file = this.urlParams.get("file");
    this.json_file = this.urlParams.get("json_file");
    await this.postLogin();
    await this.getJsonInformation();
  },
  methods: {
    toggleShowBeneficiary() {
      this.showBeneficiary = !this.showBeneficiary;
    },
    toggleShowEconomicDependent() {
      this.showEconomicDependent = !this.showEconomicDependent;
    },
    toggleShowSummary() {
      this.showSummary = !this.showSummary;
    },
    toggleShowAuthorize() {
      this.showAuthorize = !this.showAuthorize;
    },
    async postLogin() {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let data = {
        usuario_api: {
          email: "firma_autorizo@fomapo.com",
          password: "cabsa2020",
        },
      };
      await axios
        .post(this.apiCabsaCore + "login", data, config)
        .then((dataa) => {
          this.token_auth_valid = dataa.data.response.token_auth;
          localStorage.setItem("token_auth_valid", this.token_auth_valid);
        });
    },
    async getJsonInformation() {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let data = {
        token_auth: this.token_auth_valid,
        file_name: this.json_file,
        business_acronym: "LMAYE",
        process: "policy_and_discount_auth_json",
      };
      await axios
        .post(this.apiCabsaCore + "uploader/get_file_cloud", data, config)
        .then((response) => {
          if (response.data.errores == "") {
            this.url_response_json = response.data.url; // aqui se encuentra el json
            this.getJsonInformationFromUrl();
            this.is_url_expiration = false;
          } else {
            this.errors = response.data.errores;
          }
        })
        .catch((error) => {
          this.errors = error.response.data.errores;
        });
    },
    async getJsonInformationFromUrl() {
      await axios
        .get(this.url_response_json, "", "")
        .then((response) => {
          if (response.data.plan_a.policy_request != null) {
            this.plan_a_policy_request_id =
              response.data.plan_a.policy_request.policy_request_id;
          }
          if (response.data.plan_b.policy_request != null) {
            this.plan_b_policy_request_id =
              response.data.plan_b.policy_request.policy_request_id;
          }
          this.checkVerificationDone();
          this.checkDocumentsSend();
          this.policy = response.data.policy.policy_request;
          this.section = response.data.section;
          this.personalData = this.policy.client;
          this.name =
            (this.personalData.first_name ? this.personalData.first_name : "") +
            (this.personalData.second_name
              ? " " + this.personalData.second_name
              : "") +
            " " +
            this.personalData.paternal_lastname +
            (this.personalData.maternal_lastname
              ? " " + this.personalData.maternal_lastname
              : "");
          this.beneficiaryArray = this.policy.client.beneficiaries;
          this.economicDependents = this.policy.client.additionals_assured;
          this.workplace = this.policy.client.workplace;
          this.selected_products =
            Object.entries(this.policy.client.selected_products).length === 0
              ? this.policy.client.additionals_assured[0].selected_products
                  .details
              : this.policy.client.selected_products.details;
          for (let i = 0; i < this.selected_products.length; i++) {
            this.totalSumQnal += Number(this.selected_products[i].total_cost);
          }
        })
        .catch((error) => {
          console.log("Error en getJsonInformationFromUrl: ", error);
        });
    },
    async checkVerificationDone() {
      //is user validated?
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await axios
        .get(
          this.api_lineamagisterialproducts + "check_verification_done",
          {
            params: {
              policy_request_a: this.plan_a_policy_request_id
                ? this.plan_a_policy_request_id
                : 0,
              policy_request_b: this.plan_b_policy_request_id
                ? this.plan_b_policy_request_id
                : 0,
            },
          },
          config
        )
        .then((response) => {
          this.user_is_validated = true;
          console.log("Usuario verificado: ", response.request.response);
        })
        .catch((error) => {
          this.user_is_validated = false;
          console.log("Usuario NO verificado: ", error.request.response);
        });
    },
    async checkDocumentsSend() {
      //was documents send?
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      await axios
        .get(
          this.api_lineamagisterialproducts + "check_send_signatures",
          {
            params: {
              policy_request_a: this.plan_a_policy_request_id
                ? this.plan_a_policy_request_id
                : 0,
              policy_request_b: this.plan_b_policy_request_id
                ? this.plan_b_policy_request_id
                : 0,
            },
          },
          config
        )
        .then((response) => {
          this.documents_is_sended = true;
          console.log("Documentos enviados: ", response.request.response);
        })
        .catch((error) => {
          this.documents_is_sended = false;
          console.log("Documentos No enviados: ", error.request.response);
        });
    },
    async sendDocumentCincel() {
      if (!this.acceptConditions) {
        this.acceptConditions = false;
        return;
      }
      this.isLoading = true;
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let invitations = [];
      invitations.push({
        name: this.name,
        email: this.personalData.emails,
        message: "Favor de firmar la solicitud",
      });
      await axios
        .post(
          this.api_lineamagisterialproducts + "send_document_cincel",
          {
            identifier: this.file,
            process: "policy_and_discount_auth_pdf",
            business_acronym: "LMAYE",
            name_document: "solicitud final " + this.personalData.rfc,
            description: "incluye poliza(s) y autorizo",
            policy_request_a: this.plan_a_policy_request_id
              ? this.plan_a_policy_request_id
              : 0,
            policy_request_b: this.plan_b_policy_request_id
              ? this.plan_b_policy_request_id
              : 0,
            invitations: invitations,
          },
          config
        )
        .then((response) => {
          this.isLoading = false;
          this.documents_send_cincel = true;
          console.log("Documentos enviados:" + response.request);
        })
        .catch((error) => {
          this.isLoading = false;
          this.documents_send_cincel = false;
          this.errors =
            "No fue posible enviar los documentos. Por favor contacte a su asesor.";
          console.log(
            "Se presentó un error en send_document_cincel: " +
              error.response.errores
          );
        });
    },
    finish() {
      localStorage.clear();
      this.$router.push({ name: "home" });
    },
    getPrivacynotice() {
      window.open("https://www.lineamagisterial.com/aviso.php");
    },
      
    matiButton() {
      return `<mati-button id="btnMati" clientid="${this.matiClientId}" metadata='{"plan_a_policy_request_id":"${this.plan_a_policy_request_id}", "plan_b_policy_request_id":"${this.plan_b_policy_request_id}"}' flowId="${this.matiFlowid}" />`;
    },
    matiButtonLink() {
      return '<script src="https://web-button.mati.io/button.js" type="application/javascript"><//script>';
    },
    callMatiStatusVerification() {
      return this.matiStatusVerification;
    },
    getStatusVerification() {
      this.isLoading = true;
      var swal = require("sweetalert2");
      if (this.mati_identity_id == null) {
        return;
      }

      var data = {}
      if (this.plan_a_policy_request_id != ""){
        data["plan_a_policy_request_id"] = this.plan_a_policy_request_id
      }
      if (this.plan_b_policy_request_id != ""){
        data["plan_b_policy_request_id"] = this.plan_b_policy_request_id
      }
      axios
        .get(
          this.api_lineamagisterialproducts +
            "check_identity_verification_result",
          {
            params: data,
          },
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then(({ data }) => {
          console.log(data.result + "----------");
          if (data.result != undefined) {
            this.isLoading = false;
            this.registerExist = true;
            if (data.result == "reviewNeeded") {
              this.user_is_validated = false;
              swal.fire({
                title: "Aviso",
                text:
                  "Favor de verificarse de nuevo, los documentos cargados anteriormente no pudieron ser validados.",
                icon: "warning",
              });
            }
            if (data.result == "verified") {
              this.user_is_validated = true;
              swal.fire({
                title: "Aviso",
                text: "La validación se realizó correctamente",
                icon: "success",
              });
            }
          } else {
            //FALTA AGREGAR AQUI ALGUN MENSAJE POR QUE SI ES UNDEFINES DATA
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.registerExist = false;
          console.log(error);
          swal.fire({
            title: "Aviso",
            text:
              "No se pudo realizar la verificación.",
            icon: "error",
          });
        });
    },
  },
};
</script>
<style scoped>
.activeClass {
  @apply bg-gray-400;
}
h1 {
  @apply text-xl font-semibold text-center text-dark m-8;
}
.headers {
  @apply w-full bg-darkBlue p-2 pl-5 text-white font-semibold text-base;
}
.subheading {
  @apply w-1/2 text-dark p-2;
}
.partner-col {
  @apply w-full p-2 ml-5;
}
.address-col {
  @apply w-full p-2 ml-5;
}
.benefits-col {
  @apply w-1/2 p-2;
}
.beneficiaries-col {
  @apply w-full p-2 ml-5;
}
.additionals-col {
  @apply w-full p-2 ml-5;
}
@screen md {
  h1 {
    @apply text-xl;
  }
  .headers {
    @apply p-3 pl-5 text-xl;
  }
  .subheading {
    @apply w-1/6 p-4 text-center;
  }
  .partner-col {
    @apply w-3/12 ml-0 pl-10;
  }
  .address-col {
    @apply w-3/12 ml-0 pl-10;
  }
  .benefits-col {
    @apply w-3/12 ml-0;
  }
  .beneficiaries-col {
    @apply w-2/12 ml-0 pl-10;
  }
  .additionals-col {
    @apply w-1/12 ml-0;
  }
}
hr {
  border-top: 2px solid #ff561e;
}
#signature {
  border: double 2px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #ff561e, #ff561e);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
@media only screen and (max-width: 650px) {
  .hideInSmallScreens {
    display: none;
  }
}

@media only screen and (min-width: 650px) {
  .showInSmallScreens {
    display: none;
  }
}
</style>


